import React from 'react';
import { IFunnelStageData } from '../../../api';

interface Props {
  data: IFunnelStageData[];
}

export const FunnelDetails = ({ data }: Props) => {
  // Calculer les statistiques pour chaque étape
  const calculateStats = (currentIndex: number) => {
    const currentValue = data[currentIndex].value;
    const firstValue = data[0].value;
    const previousValue = currentIndex > 0 ? data[currentIndex - 1].value : currentValue;
    
    // Pourcentage par rapport au total initial
    const percentage = firstValue > 0 ? ((currentValue / firstValue) * 100).toFixed(1) : '0.0';
    
    // Pourcentage par rapport à l'étape précédente
    const previousPercentage = previousValue > 0 ? ((currentValue / previousValue) * 100).toFixed(1) : '0.0';
    
    // Perte par rapport à l'étape précédente
    const loss = currentIndex > 0 ? previousValue - currentValue : 0;
    
    return { percentage, previousPercentage, loss };
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4">Funnel details</h2>
      
      <div className="table-responsive">
        <table className="table table-hover table-bordered">
          <thead className="table-light">
            <tr>
              <th>Color</th>
              <th>Label</th>
              <th>Event</th>
              <th className="text-end">Count</th>
              <th className="text-end">% Total</th>
              <th className="text-end">% Conversion</th>
              <th className="text-end">Lost</th>
            </tr>
          </thead>
          <tbody>
            {data.map((entry, index) => {
              const stats = calculateStats(index);
              
              return (
                <tr key={entry.event}>
                  <td>
                    <div 
                      className="rounded-circle"
                      style={{ 
                        backgroundColor: entry.color,
                        width: '24px',
                        height: '24px'
                      }}
                    />
                  </td>
                  <td className="fw-semibold">{entry.label}</td>
                  <td>
                    <code className="text-muted">{entry.event}</code>
                  </td>
                  <td className="text-end fw-bold">
                    {entry.value.toLocaleString()}
                  </td>
                  <td className="text-end">
                      {stats.percentage}%
                  </td>
                  <td className="text-end">
                    {index > 0 ? (
                      <>{stats.previousPercentage}%</>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td className="text-end">
                    {index > 0 ? (
                      <span className="text-danger">
                        -{stats.loss.toLocaleString()}
                      </span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Résumé des conversions */}
      <div className="row mt-4 g-3">
        <div className="col-md-4">
          <div className="card bg-primary bg-opacity-10 border-primary">
            <div className="card-body">
              <h6 className="card-subtitle mb-2 text-primary">Conversion rate</h6>
              <h2 className="card-title mb-0">
                {data.length > 0 && data[0].value > 0
                  ? ((data[data.length - 1].value / data[0].value) * 100).toFixed(1)
                  : '0.0'}%
              </h2>
            </div>
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="card bg-success bg-opacity-10 border-success">
            <div className="card-body">
              <h6 className="card-subtitle mb-2 text-success">Total event</h6>
              <h2 className="card-title mb-0">
                {data.length > 0 ? data[0].value.toLocaleString() : '0'}
              </h2>
            </div>
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="card bg-danger bg-opacity-10 border-danger">
            <div className="card-body">
              <h6 className="card-subtitle mb-2 text-danger">Total lost</h6>
              <h2 className="card-title mb-0">
                {data.length > 0 
                  ? (data[0].value - data[data.length - 1].value).toLocaleString()
                  : '0'}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
